import { CreateInstitutionModalTranslations } from "./types";

export const deTranslations: CreateInstitutionModalTranslations = {
    title: "Institution erstellen",
    name: "Name",
    createButtonText: "Erstellen",
};
